export default "__VITE_ASSET__B63ByA5t__"